module.exports = __webpack_public_path__ + "media/images/themes/spring_bohemian/ring-22007002f40c449806bc7c1ae26a9d23.png";